export type RequestArgsType = {
  baseUrl: string
  endpoint: string
  method: string
  params?: string
  authToken?: string
  body?: string | null
}

export const createApiRequestHeaders = (authToken?: string) => {
  const basicHeader = { 'Content-Type': 'application/json' }
  if (!authToken) return basicHeader
  const authHeader = { ...basicHeader, Authorization: `Bearer ${authToken}` }
  return authHeader
}

export const url = (args: RequestArgsType): string =>
  `${args.baseUrl + args.endpoint + (args.params || '')}`

const data = (args: RequestArgsType) => {
  const body = !!args.body ? { body: args.body } : {}
  return {
    method: args.method,
    headers: createApiRequestHeaders(args.authToken),
    ...body,
  }
}

export const request = (args: RequestArgsType): Promise<Response> =>
  fetch(url(args), data(args))

export const dataMap = (
  keysMap: { [key: string]: string },
  obj: { [key: string]: string | number },
) =>
  Object.keys(obj).reduce(
    (accumulatedNewObj, key) => ({
      ...accumulatedNewObj,
      ...{ [keysMap[key] || key]: obj[key] },
    }),
    {},
  )
